var _g, _circle, _path, _path2, _path3, _circle2, _circle3, _circle4, _circle5, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtisticVisualSkills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1121_19238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.352 48.6736C66.4389 47.7896 74.2407 37.5594 77.1058 34.5022C78.5287 32.9843 79.2985 32.4709 79.871 32.0031C80.1218 31.7986 80.2051 32.0593 80.2673 32.1733C80.5824 32.7542 80.87 33.1582 81.4042 33.6766C81.9385 34.1961 82.349 34.4699 82.935 34.7594C83.0508 34.8185 83.3094 34.8917 83.1219 35.1542C82.6893 35.7599 82.2206 36.5662 80.8001 38.084C77.9362 41.1423 68.264 49.56 67.352 48.6736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9385 28.74C83.6323 26.9308 85.4508 28.3815 88.0349 25.9707C89.2031 24.8827 88.9689 30.3121 86.3941 33.06C85.3002 34.2268 83.6614 33.9438 82.4304 32.7511C81.2017 31.5582 80.8446 29.9056 81.9385 28.74Z",
    fill: "#FF7700"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.0293,
    cy: 45.1767,
    r: 29.1767,
    fill: "#FFD100"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5352 31.847C62.5352 30.8302 63.3605 30.0049 64.3773 30.0049C65.394 30.0049 66.2194 30.8302 66.2194 31.847C66.2194 32.8638 65.394 33.6891 64.3773 33.6891C63.3605 33.6891 62.5352 32.8638 62.5352 31.847Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2202 32.0906C61.9299 30.7415 62.5704 29.458 63.6496 29.2258C64.7288 28.9936 65.8405 29.9002 66.1307 31.2492C66.4209 32.5983 65.7805 33.8818 64.7013 34.114C63.6221 34.3462 62.5104 33.4396 62.2202 32.0906Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6098 34.7507C54.3196 33.4017 54.96 32.1182 56.0392 31.886C57.1185 31.6538 58.2301 32.5603 58.5203 33.9093C58.8106 35.2584 58.1702 36.5419 57.0909 36.7741C56.0117 37.0063 54.9001 36.0997 54.6098 34.7507Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.3233,
    cy: 46.0197,
    r: 3.5,
    transform: "rotate(-9.57086 24.3233 46.0197)",
    fill: "#FF7700"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.252,
    cy: 52.114,
    r: 3.5,
    transform: "rotate(-9.57086 18.252 52.114)",
    fill: "#6ADC00"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.7617,
    cy: 61.155,
    r: 3.5,
    transform: "rotate(-9.57086 18.7617 61.155)",
    fill: "#3B8AF8"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.6621,
    cy: 65.9079,
    r: 3.5,
    transform: "rotate(-9.57086 26.6621 65.9079)",
    fill: "#A655FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8018 45.9804C26.8847 46.6719 26.6894 47.368 26.259 47.9155C25.8287 48.4631 25.1984 48.8172 24.5069 48.9C23.8154 48.9829 23.1194 48.7876 22.5718 48.3573C22.0243 47.9269 21.6701 47.2966 21.5873 46.6051C21.5045 45.9137 21.6997 45.2176 22.1301 44.6701C22.5605 44.1225 23.1907 43.7684 23.8822 43.6855C24.5737 43.6027 25.2698 43.7979 25.8173 44.2283C26.3648 44.6587 26.719 45.2889 26.8018 45.9804ZM20.4738 52.0279C20.5567 52.7194 20.3615 53.4155 19.9311 53.963C19.5007 54.5105 18.8704 54.8647 18.1789 54.9475C17.4875 55.0304 16.7914 54.8351 16.2438 54.4048C15.6963 53.9744 15.3422 53.3441 15.2593 52.6526C15.1765 51.9611 15.3717 51.2651 15.8021 50.7175C16.2325 50.17 16.8627 49.8158 17.5542 49.733C18.2457 49.6502 18.9418 49.8454 19.4893 50.2758C20.0369 50.7062 20.391 51.3364 20.4738 52.0279ZM21.515 60.7188C21.5979 61.4103 21.4026 62.1063 20.9723 62.6539C20.5419 63.2014 19.9116 63.5556 19.2201 63.6384C18.5287 63.7212 17.8326 63.526 17.285 63.0956C16.7375 62.6652 16.3834 62.035 16.3005 61.3435C16.2177 60.652 16.4129 59.9559 16.8433 59.4084C17.2737 58.8609 17.9039 58.5067 18.5954 58.4239C19.2869 58.341 19.983 58.5363 20.5305 58.9667C21.0781 59.397 21.4322 60.0273 21.515 60.7188ZM29.0925 65.1003C29.1753 65.7918 28.9801 66.4879 28.5497 67.0354C28.1193 67.583 27.489 67.9371 26.7976 68.02C26.1061 68.1028 25.41 67.9076 24.8625 67.4772C24.3149 67.0468 23.9608 66.4165 23.8779 65.7251C23.7951 65.0336 23.9903 64.3375 24.4207 63.79C24.8511 63.2424 25.4814 62.8883 26.1728 62.8054C26.8643 62.7226 27.5604 62.9178 28.1079 63.3482C28.6555 63.7786 29.0096 64.4089 29.0925 65.1003ZM12.3036 57.4145C12.8006 61.5635 14.9255 65.345 18.2107 67.9273C21.4959 70.5095 25.6724 71.681 29.8213 71.184C33.9702 70.6869 37.7518 68.562 40.334 65.2768C42.9163 61.9916 44.0878 57.8152 43.5907 53.6662C43.5079 52.9747 43.1537 52.3445 42.6062 51.9141C42.0587 51.4837 41.3626 51.2885 40.6711 51.3713C39.9932 51.4525 39.4161 51.7862 39.0141 52.2575C38.5927 52.7135 38.0156 53.0471 37.3551 53.1262C36.6636 53.209 35.9675 53.0138 35.42 52.5834C34.8725 52.153 34.5183 51.5228 34.4355 50.8313L34.0669 47.7547C33.7907 45.4498 32.6103 43.3489 30.7851 41.9143C28.96 40.4797 26.6398 39.8289 24.3348 40.1051C16.6521 41.0255 11.2686 48.7758 12.3036 57.4145Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1121_19238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.3414,
    height: 23.3414,
    fill: "white",
    transform: "matrix(0.0239579 0.999713 0.999713 -0.0239579 66.0371 25.8955)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtisticVisualSkills);
export default __webpack_public_path__ + "static/media/artistic_visual_skills.b513e785d7df9139bf86666cdff64e61.svg";
export { ForwardRef as ReactComponent };